import LeistungsseiteTemplate from "@/components/feature/LeistungsseiteTemplate";
import { allTestimonials } from "@/data/testimonials";
import asset_wallbox_beratung_tablet from "@/assets/wallbox-beratung-tablet.png";
import asset_wallbox_installation_anschluss from "@/assets/wallbox-installation-anschluss.png";
import asset_wallbox_pv_laden_sonnenuntergang from "@/assets/wallbox-pv-laden-sonnenuntergang.png";
import asset_wallbox_anmeldung_netzbetreiber from "@/assets/wallbox-anmeldung-netzbetreiber.png";
import asset_wallbox_crosslink_pv_dach from "@/assets/wallbox-crosslink-pv-dach.png";
import Seo, { serviceSchema } from "@/components/feature/Seo";

export default function Wallbox() {
  return (
    <>
      <Seo
        title="Wallbox & E-Mobilität | Zweering Elektrotechnik Emmerich am Rhein"
        description="Wallbox-Installation vom Elektro-Meisterbetrieb: Beratung, Anmeldung, Anschluss und Service aus einer Hand — für Ihr Zuhause in Emmerich am Rhein und Umgebung."
        canonical="https://zweering.de/wallbox"
        breadcrumbs={[{"name": "Startseite", "url": "https://zweering.de/"}, {"name": "Leistungen", "url": "https://zweering.de/wallbox"}, {"name": "Wallbox & E-Mobilität", "url": "https://zweering.de/wallbox"}]}
        schema={serviceSchema("Wallbox-Installation", "Beratung, Anmeldung beim Netzbetreiber und normgerechte Installation von Wallboxen für Privat und Gewerbe in Emmerich am Rhein und Umgebung.", "https://zweering.de/wallbox")}
      />
      <LeistungsseiteTemplate
      label="LEISTUNGEN"
      title="WALLBOX & E-MOBILITÄT"
      subline="Laden zuhause — sicher, schnell und förderfähig. Wallbox-Installation vom Elektro-Meisterbetrieb aus einer Hand, in Emmerich am Rhein und Umgebung."
      heroImage="https://www.zweering-elektrotechnik.de/wp-content/uploads/2025/11/IMG_0105.webp"
      heroImageAlt="Wallbox an einem Einfamilienhaus in Emmerich am Rhein"
      leadText={
        <>
          Ein E-Auto lädt man nicht an der Steckdose. Eine fest installierte Wallbox lädt
          schneller, sicherer und günstiger — und ist als Elektroinstallation{" "}
          <span style={{ color: "#4CAF50" }}>Sache des Fachbetriebs</span>, nicht des
          Baumarkts.
        </>
      }
      panels={[
        {
          title: "BERATUNG & CHECK",
          body: "Welche Wallbox passt zu Ihrem Auto, Ihrem Hausanschluss und Ihrem Alltag? Wir prüfen Anschluss und Leistung und empfehlen die richtige Lösung — herstellerunabhängig.",
          image: asset_wallbox_beratung_tablet,
          imageAlt: "Persönliche Wallbox-Beratung am Esstisch mit Grundriss auf dem Tablet durch Zweering Elektrotechnik",
        },
        {
          title: (
            <>
              SICHERE <span style={{ color: "#4CAF50" }}>INSTALLATION</span>
            </>
          ),
          body: "Anschluss, Absicherung und Leitungsschutz durch unseren Elektro-Meisterbetrieb. Eine Wallbox ist eine Festinstallation — fachgerecht ausgeführt und angemeldet.",
          image: asset_wallbox_installation_anschluss,
          imageAlt: "Elektro-Meister beim fachgerechten Anschluss einer Wallbox an der Hauswand durch Zweering Elektrotechnik",
        },
        {
          title: "INTELLIGENT LADEN",
          body: "Ihre Wallbox kann mit Ihrer PV-Anlage und Ihrem Speicher zusammenarbeiten — laden Sie Ihr Auto mit Ihrem eigenen Sonnenstrom.",
          image: asset_wallbox_pv_laden_sonnenuntergang,
          imageAlt: "E-Auto lädt an Wallbox vor Einfamilienhaus mit PV-Anlage im Sonnenuntergang in Emmerich am Rhein",
        },
        {
          title: "ANMELDUNG INKLUSIVE",
          body: "Anmeldung beim Netzbetreiber und alle Formalitäten übernehmen wir — aus einer Hand, ohne Aufwand für Sie.",
          image: asset_wallbox_anmeldung_netzbetreiber,
          imageAlt: "Anmeldeunterlagen für Wallbox beim Netzbetreiber auf Schreibtisch mit Laptop",
        },
      ]}
      testimonials={allTestimonials}
      trustLine="Vertrauen unserer Kundinnen und Kunden am Niederrhein."
      manifest={"ZUHAUSE LADEN.\nMIT EIGENEM STROM.\nEINFACH ANKOMMEN."}
      caseStudy={{
        title: "WALLBOX MIT PV-ANBINDUNG",
        text: "Wallbox installiert und mit bestehender PV-Anlage verbunden — Laden mit eigenem Sonnenstrom, aus einer Hand in Emmerich am Rhein und Umgebung.",
        href: "#referenzen",
        image: "https://www.zweering-elektrotechnik.de/wp-content/uploads/2024/03/IMG_0106-Kopie.jpg",
        imageAlt: "Referenz: Wallbox mit PV-Anbindung in Emmerich am Rhein",
      }}
      faq={[
        {
          frage: "Darf ich eine Wallbox selbst anschließen?",
          antwort:
            "Nein. Eine Wallbox ist eine Festinstallation und muss von einem Elektrofachbetrieb angeschlossen und beim Netzbetreiber angemeldet werden.",
        },
        {
          frage: "Kann ich mein Auto mit Solarstrom laden?",
          antwort:
            "Ja. Wenn Sie eine PV-Anlage haben, kann die Wallbox vorrangig Ihren eigenen Sonnenstrom nutzen — wir binden beides zusammen ein.",
        },
        {
          frage: "Welche Wallbox empfehlen Sie?",
          antwort:
            "Wir sind herstellerunabhängig und empfehlen die Wallbox, die zu Ihrem Auto, Hausanschluss und Budget passt.",
        },
        {
          frage: "Gibt es Förderung für Wallboxen?",
          antwort:
            "Förderprogramme ändern sich. Wir informieren Sie in der Beratung über die aktuell verfügbaren Möglichkeiten.",
        },
      ]}
      ctaText={{
        headline: "BEREIT FÜRS LADEN ZUHAUSE?",
        subtext: "Kostenlose Beratung — wir finden die passende Wallbox für Sie.",
        buttonLabel: "Erstberatung anfragen",
        buttonHref: "/kontakt",
        variant: "green",
      }}
      crossLink={{
        title: "PHOTOVOLTAIK",
        text: "Laden Sie mit eigenem Sonnenstrom — so fängt es an.",
        href: "/photovoltaik",
        image: asset_wallbox_crosslink_pv_dach,
        imageAlt: "Photovoltaikanlage auf rotem Ziegeldach eines Einfamilienhauses in Emmerich am Rhein",
      }}
    />
    </>
  );
}
